const WalletService = {
    getActive : (wallets, type) => {
        const fixNullArray = wallets ? wallets : [];
        return fixNullArray.filter((wallet) => {
            const isNotDeleted = wallet?.state !== "DELETED";
            const isNotInactive = wallet?.active !== false && wallet?.active !== "false";
            const isTypeMatch = type === "ALL" || !type || wallet?.walletType === type;
            return isNotDeleted && isNotInactive && isTypeMatch;
        });
    }
}

export default WalletService